// extracted by mini-css-extract-plugin
export var typingIndicator = "_ox-0";